import { observer } from "mobx-react-lite";
import React from "react";
import { List, Message, Segment } from "semantic-ui-react";
import  styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/family/";

const CognitiveImpairmentLearnMore: React.FC = () => {

  const renderAccordionPlans = () => {
    return (
      <>
      <Segment raised className={styles.segmentWhiteBG} > 
      <List divided relaxed bulleted className={styles.learnMoreBulletedList}  >
          <>
            <List.Item header="MCI" 
              description="Older adults with mild cognitive impairment (MCI) have more trouble with memory than is typical of people of their age, but their memory problems do not significantly affect daily living.  Those with MCI are at greater risk for developing dementia, but MCI does not always progress to dementia." />
            <List.Item header="Dementia" 
              description="According to the Alzheimer’s Association dementia is “a general term for loss of memory, language, problem-solving and other thinking abilities that are severe enough to interfere with daily life. Alzheimer's is the most common cause of dementia.” About 10% of adults 65 and older have dementia, and the percentage increases with advancing age." />
            <List.Item header="Detection" 
              description="If your older adult is having trouble with activities of daily living because of cognitive problems, it is desirable to consult a neurologist. Neurologists can identify the cause(s) of the cognitive problems and provide treatments that may control the symptoms, and/or slow the progress of disease. They can also suggest interventions to help family members and others care for the person with impairments." />
          </>
        </List>
    </Segment>     
      </>
    );
  };
  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}CrisisPlanningInfoTwoRight.jpg)`, }}>
        <div className={styles.learnMoreModalContentCognitiveImpairment}>
          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionPlans()}/>
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(CognitiveImpairmentLearnMore);
